const PERMISSIONS = {
  UNDEFINED: 0,
  STUDENT: 1000,
  COLLABORATOR: 3000,
  OWNER: 5000,
};

module.exports = PERMISSIONS;
